import { PageId } from 'constants/pages'

export const enum PageIdWoofzXmas70 {
  SUBSCRIPTIONS_XMAS_70 = PageId.SUBSCRIPTIONS_XMAS_70,
  CHAT_UPSELL_XMAS_70 = PageId.CHAT_UPSELL_XMAS_70,
  UPSELL_XMAS_70 = PageId.UPSELL_XMAS_70,
  DOWNLOAD_XMAS_70 = PageId.DOWNLOAD_XMAS_70,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
